import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FaTag, FaTimes } from "react-icons/fa";
import {
  clearPendingDiscount,
  pricingPath,
  usePendingDiscount,
} from "../../utils/pendingDiscount";

// Strip under the header while a discount code is waiting to be used, so a
// visitor who left the pricing page (to the home page, to log in, to reset a
// password…) can always get back to it with the code applied.
const DiscountBanner = () => {
  const code = usePendingDiscount();
  const { pathname } = useLocation();
  if (!code || pathname === "/pricing" || pathname.startsWith("/checkout")) {
    return null;
  }
  return (
    <div dir="rtl" className="bg-primary text-header font-sans">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 py-2 flex items-center gap-3">
        <FaTag className="shrink-0" aria-hidden="true" />
        <p className="flex-1 min-w-0 text-sm font-semibold leading-snug">
          عندك كود خصم{" "}
          <bdi dir="ltr" className="font-extrabold">
            {code}
          </bdi>{" "}
          محفوظ
          <span className="hidden sm:inline">، يُطبَّق على الباقات في صفحة الاشتراك</span>
        </p>
        <Link
          to={pricingPath(code)}
          className="shrink-0 rounded-lg bg-header text-white text-sm font-bold px-3 py-1.5 hover:bg-background"
        >
          اشترك الآن
        </Link>
        <button
          type="button"
          onClick={clearPendingDiscount}
          className="shrink-0 p-1.5 -m-1 rounded-md hover:bg-header/10"
          aria-label="إخفاء كود الخصم"
        >
          <FaTimes aria-hidden="true" />
        </button>
      </div>
    </div>
  );
};

// Inline reassurance on the login / sign-up forms.
export const DiscountNote = () => {
  const code = usePendingDiscount();
  if (!code) return null;
  return (
    <div
      dir="rtl"
      className="flex items-start gap-2.5 rounded-xl border border-primary/40 bg-primary/10 px-3.5 py-3 text-sm text-white"
    >
      <FaTag className="mt-0.5 shrink-0 text-primary" aria-hidden="true" />
      <p className="leading-relaxed">
        كود الخصم{" "}
        <bdi dir="ltr" className="font-extrabold text-primary">
          {code}
        </bdi>{" "}
        محفوظ، وبعد الدخول يُطبَّق تلقائياً في صفحة الاشتراك.
      </p>
    </div>
  );
};

export default DiscountBanner;
